import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import orbitService from "../modules/orbit-module/services/orbit-service";
import { setUserDetails } from "../feature/auth-slice";
import {
  setAuthToken,
  setCompanyDetails,
  setIsAdmin,
  setIsCitizen,
  setIsVolunteer,
  setOrbitDetails,
  setUserImage,
} from "../feature/auth-slice/auth-slice";
import { setMainOrbit, setSelectOrbit } from "../feature/orbit-slice";
import { getCookie } from "./cookie";
import { useNavigate } from "react-router";
import { getLocalData, setLocalData } from "./localstorage";

export const useGetOrbitDetails = (nav: boolean = false,vol:boolean=false) => {
  const navigate = useNavigate();
  const volenteer = getLocalData("volenteer");
  const dispatch = useDispatch();
  const adminType = 1;
  const citizenType = 2;
  const volenteerType = 3;

  const { mutate: getDetail, ...mutationRest } = useMutation({
    mutationFn: orbitService.getDetails,
    onSuccess: (data) => {
      dispatch(setUserDetails(data.data.user_details));
      dispatch(setCompanyDetails(data.data.company_details));
      dispatch(setAuthToken(data.data.access_token));
      dispatch(setMainOrbit(data.data.orbit_details.orb_id));
      dispatch(setUserImage(data.data.user_details.imageUrl));
      dispatch(setOrbitDetails(data.data.orbit_details));
      setUserType(data.data.user_details.usr_type);
      if (!volenteer || vol) {
        setLocalData("volenteer", data.data.user_details);
      }
      // if (nav) {
      //   dispatch(setSelectOrbit(data.data.orbit_details.orb_id));
      //   navigate({
      //     pathname: "/orbit",
      //     search: `?fr=home`,
      //   });
      // }
    },
  });


  const setUserType = (type: any) => {
    dispatch(setIsAdmin(type === adminType));
    dispatch(setIsCitizen(type === citizenType));
    dispatch(setIsVolunteer(type === volenteerType));
  };

  return { getDetail, ...mutationRest };
};
